(function () {
    'use strict';

    angular.module("imApp").factory("checkPointHeadsService", ['$ihttp', function ($ihttp) {
        let service = {
            listCheckPoints: function (parms) {
                return $ihttp.post({
                    method: 1667,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
